if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
  
}
 function filtervariantimages() { 
     var curr=document.querySelector("input[name='Color']:checked").value;
  
   
    var eles=Array.from(document.querySelectorAll(".after-content .product__media-list .product__media-item"));
    eles=eles.concat(Array.from(document.querySelectorAll("product-modal.remaining img")));
    for(var i=0;i<eles.length;i++)
    eles[i].style.display='none';
  
    eles=Array.from(document.querySelectorAll(".after-content .product__media-list .product__media-item img[alt='"+curr+"']"));
    eles=eles.concat(Array.from(document.querySelectorAll(".after-content .product__media-list .product__media-item img[alt='']")));
    for(var i=0;i<eles.length;i++)
    eles[i].parentNode.parentNode.parentNode.parentNode.style.display='block';
    eles= Array.from(document.querySelectorAll("product-modal.remaining img[alt='"+curr+"']"));
    eles=eles.concat(Array.from(document.querySelectorAll("product-modal.remaining img[alt='']"))); 
    for(var i=0;i<eles.length;i++)
    eles[i].style.display='block';
 } 
 
/*Array.from(document.querySelectorAll("input[name='Color']")).forEach((element,index) =>
{
  element.onchange=function(){  filtervariantimages();}
});*/
 window.onload=function(){ 
/*document.querySelector("variant-radios").addEventListener('change',function( ){
    if (GloboPreorderParams && GloboPreorderParams.product.available == true) {
       document.querySelector(".product-form__input.product-form__quantity label").style.display='none'; 
       document.querySelector(".shopify-payment-button__button").innerHTML='pre order';
    } 
  } );
      document.querySelector(".product__column-sticky.single-media").style.display='block';
   if(Array.from(document.querySelectorAll("input[name='Color']")).length>0)
   { 
      var curr=document.querySelector("input[name='Color']:checked").value;
    var eles=Array.from(document.querySelectorAll(".product__media-wrapper .product__media-list .product__media-item")); 
    for(var i=0;i<eles.length;i++)
    eles[i].parentNode.parentNode.parentNode.parentNode.classList.remove('is-active');
    eles=document.querySelector(".product__media-wrapper .product__media-list .product__media-item img[alt='"+curr+"']");
    eles.parentNode.parentNode.parentNode.parentNode.classList.add('is-active');
      filtervariantimages();
     document.querySelector("variant-radios").dispatchEvent(new Event("change"));
   } */
   if(document.querySelector("#cbanner video"))
   {
     document.querySelector("#cbanner video").play();
   }
 }
  